import { useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import "../css/login.css";

function ForgotPassword() {

  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const res = await axios.post(
        `${API_URL}/forgot-password`,
        { email }
      );

      alert(res.data.message);

      setEmail("");

    } catch (err) {

      alert(
        err.response?.data?.message ||
        "Something went wrong."
      );

    }

  };

  return (

    <div className="login-page">

      <div className="login-card">

        <h1>Forgot Password</h1>

        <p>Enter your registered email address.</p>

        <form
          className="login-form"
          onSubmit={handleSubmit}
        >

          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            required
          />

          <button type="submit">
            Send Reset Link
          </button>

        </form>

      </div>

    </div>

  );

}

export default ForgotPassword;